export const DEFAULT_PLACEHOLDER = 'Select date';
